<template>
  <div class="banner__container">
    <div class="banner__wrapper mx-auto d-flex align-center">
      <p class="mb-0 font-weight-bold">
        Our site uses cookies, by closing this cookie window or continuing to
        use our website you are consenting to our use of cookies. You can
        <a
          class="text-decoration-underline"
          @keydown.enter="openModalWithParams('DialogContentCookies', 800)"
          @click="openModalWithParams('DialogContentCookies', 800)"
          >read our policy here</a
        >
        which includes information on how to manage cookies.
      </p>
      <div class="d-flex flex-column font-weight-bold">
        <v-icon size="40" color="#FFF" @click="acceptCookies">mdi-close</v-icon>
        <button type="button" @click="acceptCookies">CLOSE</button>
      </div>
    </div>
  </div>
</template>

<script>
import { DIALOG_MODULE } from "@/store/types/module-types";
import { mapMutations } from "vuex";
export default {
  name: "CookieBanner",
  methods: {
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    acceptCookies() {
      localStorage.setItem("acceptedCookie", JSON.stringify(true));
      window.dispatchEvent(
        new CustomEvent("acceptedCookie-localstorage-changed", {
          detail: {
            storage: JSON.parse(localStorage.getItem("acceptedCookie")),
          },
        })
      );
    },
    openModalWithParams(dialogComponentName, dialogWidth) {
      const payload = { dialogWidth, dialogComponentName };
      this.showModal(payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner__container {
  background-color: #272727;
  padding: 16px 36px;
  z-index: 11;
  position: fixed;
  bottom: 0;
  width: 100%;
  color: #fff;
  a {
    color: $secondary;
  }
  p {
    padding-right: 16px;
  }
  .banner__wrapper {
    max-width: 1200px;
    letter-spacing: 0.4px;
  }
}
@media screen and (min-width: $grid-breakpoints-lg) {
  .banner__container {
    padding: 27px 75px;

    p {
      padding-right: 142px;
    }
  }
}
</style>
